var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5417 0H3.06914C2.35306 0 1.6663 0.284463 1.15995 0.790812C0.653604 1.29716 0.369141 1.98392 0.369141 2.7V21.6H18.3691V6.8274L11.5417 0ZM12.0691 3.0726L15.2965 6.3H12.0691V3.0726ZM2.16914 19.8V2.7C2.16914 2.46131 2.26396 2.23239 2.43274 2.0636C2.60153 1.89482 2.83045 1.8 3.06914 1.8H10.2691V8.1H16.5691V19.8H2.16914ZM12.9304 11.2113L10.6417 13.5L12.9304 15.7887L11.6578 17.0613L9.36914 14.7726L7.08044 17.0613L5.80784 15.7887L8.09654 13.5L5.80784 11.2113L7.08044 9.9387L9.36914 12.2274L11.6578 9.9387L12.9304 11.2113Z",
    fill: "#BABABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.fdb33787a50037cb5f437b1de7c1359c.svg";
export { ForwardRef as ReactComponent };